import { paymentForGrid } from '../../../spd/components/Payments/Payments';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  CreateUpdatePaymentDto,
  GetPaymentDto,
} from '../autogenerated/spdApiClient';
import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';

export type Payment = GetPaymentDto;

export interface PaymentContextInterface {
  getById: (id: string | null | undefined) => Promise<Payment | undefined>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    setRefresh?: () => void | undefined,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  getSellDocumentNotIssuedByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    setRefresh?: () => void | undefined,
  ) => Promise<GridRecord[]>;
  getSellDocumentNotIssuedCount: (
    filterText?: string,
    filterColumns?: string,
  ) => Promise<number>;
  getByExamId: (examId: string) => Promise<GetPaymentDto[]>;
  update: (id: string, dto: CreateUpdatePaymentDto) => Promise<GetPaymentDto>;
}

export const PaymentContext = (api: DefaultApi) => {
  return {
    getById: async (id: string | null | undefined) => {
      if (!id || id === undefined) {
        return;
      }
      return await api.paymentControllerFindOne(id);
    },

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
      setRefresh?: () => void | undefined,
    ) => {
      const data = await api.paymentControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns || '',
      );
      return data.map(item => paymentForGrid(item, setRefresh));
    },

    getAllCount: (filterText?: string, filterColumns?: string) =>
      api.paymentControllerCount(filterText || '', filterColumns || ''),

    getSellDocumentNotIssuedByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
      setRefresh?: () => void | undefined,
    ) => {
      const data = await api.paymentControllerGetSellDocumentNotIssuedByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns || '',
      );
      return data.map(item => paymentForGrid(item, setRefresh));
    },

    getSellDocumentNotIssuedCount: (
      filterText?: string,
      filterColumns?: string,
    ) =>
      api.paymentControllerGetSellDocumentNotIssuedCount(
        filterText || '',
        filterColumns || '',
      ),

    getByExamId: (examId: string) => api.paymentControllerGetByExam(examId),

    update: (id: string, dto: CreateUpdatePaymentDto) =>
      api.paymentControllerUpdate(id, dto),
  };
};
